import { addStyles } from 'ethcss'
import { colors, grid, IStyles, item, mediaCSS } from '../../../theme'
import { defaultThemeStyles } from 'blocks.app/app/app.theme.jcss'
import { textSizes } from 'theme/media'

const devicesTags: IStyles = {
    devicesTags: {
        marginTop: 20,
    },
    table: {
        width: '100%',

        th: {
            backgroundColor: colors.greyLight,
            padding: 10,
            textAlign: 'left',
            border: `1px solid ${colors.greyBorder}`,
            verticalAlign: 'middle',
        },
        td: {
            padding: 10,
            verticalAlign: 'middle',
        },
    },
    checkboxCol: {
        width: 40,
        paddingRight: '4px !important',
    },
    nameCol: {
        width: '50%',
    },
    devicesCol: {
        width: '50%',
    },
    search: {
        marginBottom: 20,
    },
}

addStyles(devicesTags)
export default devicesTags
